import type { PayloadError } from 'relay-runtime';

// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { isApolloError } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';

import { BadStatusError } from './BadStatusError.ts';

const CAUGHT_SESSION_ERROR_TEXT = 'Session expired';

export class SessionExpiredError extends BadStatusError {
	constructor(message: string, response: Response) {
		super(`${message} ${CAUGHT_SESSION_ERROR_TEXT}`, response);
	}
}

// At the moment when we invoke the function it's still a generic Object
export type GraphQLErrorLikeObject = {
	extensions: {
		statusCode: number;
	};
};

export function isSessionExpiredError(
	error: Error | GraphQLErrorLikeObject | PayloadError | null,
): boolean {
	if (!error) {
		return false;
	}
	if (error instanceof SessionExpiredError) {
		return true;
	}
	const errorMessage = (error as Error)?.message || '';
	if (errorMessage.indexOf(CAUGHT_SESSION_ERROR_TEXT) != -1) {
		return true;
	}
	const errorStatusCode = (error as GraphQLErrorLikeObject)?.extensions?.statusCode;
	if (errorStatusCode == 401) {
		return true;
	}
	return false;
}

export function containsSessionExpiredError(error: Error | null): boolean {
	if (!error) {
		return false;
	}

	if (isSessionExpiredError(error)) {
		return true;
	}

	if (isApolloError(error)) {
		const { graphQLErrors, networkError } = error;
		if (isSessionExpiredError(networkError)) {
			return true;
		}

		if ((graphQLErrors || []).some(isSessionExpiredError)) {
			return true;
		}
	}

	return false;
}
